import React from 'react'

import { FieldLabel      } from './fields/label'
import { TextFieldEditor } from './text/text'

export const DetailsTextEdit = ({label,topic,...props}) => (<tr>
  <FieldLabel value={label} topic={topic || label} />
  <td><TextFieldEditor {...props} /></td>
</tr>)
